import React, { useState } from 'react';
import { Grid, Box, Alert, Button, Typography } from '@mui/material';
import Header from '../components/Dashboard/Header';
import CardsIndicadores from '../components/Dashboard/CardsIndicadores';
import PalanqueTop5 from '../components/Dashboard/PalanqueTop5';
import ListaCorretores from '../components/Dashboard/ListaCorretores';
import SpotifyPlayer from '../components/Dashboard/SpotifyPlayer';
import { useApp } from '../context/AppContext';

function Dashboard() {
  const meses = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
  ];
  const mesAtual = meses[new Date().getMonth()];
  const anoAtual = new Date().getFullYear();

  const [mesSelecionado, setMesSelecionado] = useState(mesAtual);
  const [anoSelecionado, setAnoSelecionado] = useState(anoAtual);
  const [filtroVGV, setFiltroVGV] = useState('Todos');
  const [filtroAtivo, setFiltroAtivo] = useState('Sim');
  const [showFiltros, setShowFiltros] = useState(false);
  const { loading, error } = useApp();

  // TELA DE ERRO COM FUNDO ATUALIZADO
  if (error && !loading) {
    return (
      <Box
        sx={{
          height: '100vh',
          width: '100vw',
          // Fundo escuro com luz central para destacar o erro
          background: 'radial-gradient(circle, #2c2c2c 0%, #0a0a0a 100%)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          p: 4,
        }}
      >
        <Header />
        <Alert 
          severity="error" 
          sx={{ 
            maxWidth: 800, 
            mb: 2,
            backgroundColor: 'rgba(211, 47, 47, 0.2)',
            color: '#fff',
            border: '1px solid rgba(211, 47, 47, 0.5)',
            '& .MuiAlert-message': { width: '100%' }
          }}
        >
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold' }}>
            Erro ao carregar dados
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            {error}
          </Typography>
          <Button
            variant="contained"
            onClick={() => window.location.reload()}
            sx={{ mt: 1, backgroundColor: '#d32f2f' }}
          >
            Tentar Novamente
          </Button>
        </Alert>
      </Box>
    );
  }

  // TELA PRINCIPAL DO DASHBOARD
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        // Efeito de palco premium para destacar os metais
        background: 'radial-gradient(circle, #2c2c2c 0%, #050505 100%)',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Container do Header */}
      <Box sx={{ flexShrink: 0, mb: 1, px: 3, pt: 2 }}>
        <Header
          showFiltros={showFiltros}
          onToggleFiltros={() => setShowFiltros(!showFiltros)}
          mesSelecionado={mesSelecionado}
          setMesSelecionado={setMesSelecionado}
          anoSelecionado={anoSelecionado}
          setAnoSelecionado={setAnoSelecionado}
          filtroVGV={filtroVGV}
          setFiltroVGV={setFiltroVGV}
          filtroAtivo={filtroAtivo}
          setFiltroAtivo={setFiltroAtivo}
        />
      </Box>

      {/* Grid Principal */}
      <Box sx={{ flex: 1, overflow: 'hidden', px: 3, pb: 3 }}>
        <Grid container spacing={3} sx={{ height: '100%' }}>
          
          {/* LADO ESQUERDO: Indicadores e Pódio */}
          <Grid item xs={12} md={9} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ 
              flex: 1, 
              display: 'flex', 
              flexDirection: 'column', 
              overflow: 'hidden',
              justifyContent: 'space-between' 
            }}>
              {/* Cards de Indicadores */}
              <Box sx={{ flexShrink: 0, mb: 2 }}>
                <CardsIndicadores
                  mesSelecionado={mesSelecionado}
                  anoSelecionado={anoSelecionado}
                />
              </Box>

              {/* Pódio (Palanque) - Ocupando a área inferior */}
              <Box sx={{ flex: 1, display: 'flex', alignItems: 'flex-end', minHeight: 0 }}>
                <PalanqueTop5
                  mesSelecionado={mesSelecionado}
                  anoSelecionado={anoSelecionado}
                  filtroAtivo={filtroAtivo}
                />
              </Box>
            </Box>
          </Grid>

          {/* LADO DIREITO: Ranking Geral e Player */}
          <Grid item xs={12} md={3} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ 
              flex: 1, 
              display: 'flex', 
              flexDirection: 'column', 
              overflow: 'hidden',
              backgroundColor: 'rgba(255, 255, 255, 0.03)', // Fundo sutil para a lista
              borderRadius: '16px',
              p: 2,
              border: '1px solid rgba(255, 255, 255, 0.05)'
            }}>
              <Box sx={{ flex: 1, minHeight: 0, mb: 2 }}>
                <ListaCorretores
                  mesSelecionado={mesSelecionado}
                  anoSelecionado={anoSelecionado}
                  filtroAtivo={filtroAtivo}
                  filtroVGV={filtroVGV}
                />
              </Box>
              
              <Box sx={{ flexShrink: 0 }}>
                <SpotifyPlayer />
              </Box>
            </Box>
          </Grid>

        </Grid>
      </Box>
    </Box>
  );
}

export default Dashboard;

//---------- COM IMAGEM NO FUNDO ABAIXO

// import React, { useEffect, useState } from 'react';
// import { Grid, Box, Alert, Button, Typography } from '@mui/material';
// import Header from '../components/Dashboard/Header';
// import CardsIndicadores from '../components/Dashboard/CardsIndicadores';
// import PalanqueTop5 from '../components/Dashboard/PalanqueTop5';
// import ListaCorretores from '../components/Dashboard/ListaCorretores';
// import SpotifyPlayer from '../components/Dashboard/SpotifyPlayer';
// import { useApp } from '../context/AppContext';

// function Dashboard() {
//   const meses = [
//     'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
//     'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
//   ];
//   const mesAtual = meses[new Date().getMonth()];
//   const anoAtual = new Date().getFullYear();

//   const [mesSelecionado, setMesSelecionado] = useState(mesAtual);
//   const [anoSelecionado, setAnoSelecionado] = useState(anoAtual);
//   const [filtroVGV, setFiltroVGV] = useState('Todos');
//   const [filtroAtivo, setFiltroAtivo] = useState('Sim');
//   const [showFiltros, setShowFiltros] = useState(false);
//   const [tipoRankingTop5, setTipoRankingTop5] = useState('vgv');
//   const { loading, error } = useApp();

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setTipoRankingTop5(prev => (prev === 'vgv' ? 'pontuacao_meta' : 'vgv'));
//     }, 60000);
//     return () => clearInterval(interval);
//   }, []);

//   if (error && !loading) {
//     return (
//       <Box
//         sx={{
//           height: '100vh',
//           backgroundImage: 'url("/fundodash.png")',
//           backgroundSize: 'cover',
//           backgroundPosition: 'center',
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           justifyContent: 'center',
//           p: 4,
//         }}
//       >
//         <Header />
//         <Alert 
//           severity="error" 
//           sx={{ 
//             maxWidth: 800, 
//             mb: 2,
//             '& .MuiAlert-message': { width: '100%' }
//           }}
//         >
//           <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold' }}>
//             Erro ao carregar dados
//           </Typography>
//           <Typography variant="body1" sx={{ mb: 2 }}>
//             {error}
//           </Typography>
//           <Button
//             variant="contained"
//             onClick={() => window.location.reload()}
//             sx={{ mt: 1 }}
//           >
//             Tentar Novamente
//           </Button>
//         </Alert>
//       </Box>
//     );
//   }

//   return (
//     <Box
//       sx={{
//         height: '100vh',
//         width: '100vw',
//         // Configuração da Imagem de Fundo
//         backgroundImage: 'url("/fundodash.png")',
//         backgroundSize: 'cover',
//         backgroundPosition: 'center',
//         backgroundRepeat: 'no-repeat',
//         backgroundAttachment: 'fixed', // Mantém o fundo fixo ao scrollar, se houver
//         overflow: 'hidden',
//         display: 'flex',
//         flexDirection: 'column',
//       }}
//     >
//       {/* Container do Header com a largura que você definiu */}
//       <Box sx={{ flexShrink: 0, mb: 2, width: '98%', mx: 'auto' }}>
//         <Header
//           showFiltros={showFiltros}
//           onToggleFiltros={() => setShowFiltros(!showFiltros)}
//           mesSelecionado={mesSelecionado}
//           setMesSelecionado={setMesSelecionado}
//           anoSelecionado={anoSelecionado}
//           setAnoSelecionado={setAnoSelecionado}
//           filtroVGV={filtroVGV}
//           setFiltroVGV={setFiltroVGV}
//           filtroAtivo={filtroAtivo}
//           setFiltroAtivo={setFiltroAtivo}
//         />
//       </Box>

//       {/* Container do Conteúdo Principal */}
//       <Box sx={{ flex: 1, overflow: 'hidden', px: 2, width: '98%', mx: 'auto' }}>
//         <Grid container spacing={2} sx={{ height: '100%' }}>
//           {/* Lado Esquerdo - Cards e Palanque */}
//           <Grid item xs={12} md={9} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
//             <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', pr: 1, overflow: 'hidden', justifyContent: 'flex-end' }}>
//               <Box sx={{ flex: 1, overflow: 'auto', mb: 0, minHeight: 0 }}>
//                 <CardsIndicadores
//                   mesSelecionado={mesSelecionado}
//                   anoSelecionado={anoSelecionado}
//                 />
//               </Box>
//               <Box sx={{ flexShrink: 0 }}>
//                 <PalanqueTop5
//                   mesSelecionado={mesSelecionado}
//                   anoSelecionado={anoSelecionado}
//                   filtroAtivo={filtroAtivo}
//                   tipoRanking={tipoRankingTop5}
//                 />
//               </Box>
//             </Box>
//           </Grid>

//           {/* Lado Direito - Lista de Corretores e Spotify */}
//           <Grid item xs={12} md={3} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
//             <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', pl: 1, overflow: 'hidden' }}>
//               <Box sx={{ flex: 1, minHeight: 0, mb: 2 }}>
//                 <ListaCorretores
//                   mesSelecionado={mesSelecionado}
//                   anoSelecionado={anoSelecionado}
//                   filtroAtivo={filtroAtivo}
//                   filtroVGV={filtroVGV}
//                 />
//               </Box>
//               <Box sx={{ flexShrink: 0 }}>
//                 <SpotifyPlayer />
//               </Box>
//             </Box>
//           </Grid>
//         </Grid>
//       </Box>
//     </Box>
//   );
// }

// export default Dashboard;
